import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import EMPButton from "../../shared/components/EMPButton/EMPButton";

const PublishButton = ({
  overridesApplied,
  styles,
  t,
  enablePublishBtn,
}) => {
  return overridesApplied ? (
    <div className={styles.overridesApplied}>
      <span>{"✓ "}</span>
      {t("CategorySettings.overridesApplied")}
    </div>
  ) : (
    <Box textAlign="center" mt={2}>
      <EMPButton
        variant="contained"
        disabled={!enablePublishBtn}
        testId="publishAccessoriesSettingsFees"
        submitButton
      >
        {t("NamePlate.publishOverrides")}
      </EMPButton>
    </Box>
  );
};

PublishButton.propTypes = {
  overridesApplied: PropTypes.bool,
  styles: PropTypes.shape({
    overridesApplied: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
  enablePublishBtn: PropTypes.bool,
};

PublishButton.defaultProps = {
  overridesApplied: false,
  enablePublishBtn: false,
};

export default PublishButton;
